
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../../models/user';
import { environment } from '../../../environments/environment';
declare let google: any;


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    public currentUserObj: User;
    public minutiOffset: number = 30;

    constructor(
        private http: HttpClient
    ) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    baseUrl: string = environment.backend.baseUrl_utenti;
    pathUrl: string = environment.backend.pathUrl.utenti.authentication_controller;
    url: string = this.baseUrl + this.pathUrl;
    googleLoginOptions = {
        scope: 'profile email'
    };

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    public set setCurrentUserValue(currentUser: User) {
        this.currentUserSubject = new BehaviorSubject<User>(currentUser);
    }


    setUserGoogle(socialUser) {
        if (this.currentUserObj == null) {
            this.currentUserObj = new User();
        }
        this.currentUserObj.userGoogle = socialUser;
        this.currentUserObj.email = socialUser.email;
        this.currentUserObj.token = socialUser.authToken;
    }
    setUserBackend(response) {
        this.currentUserObj.userBackend = response;
    }


    getCurrentUserLocalstorage() {
        return JSON.parse(localStorage.getItem("currentUser"));
    }


    loginBackend(token: string) {
        let url = this.url;
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', 'Bearer ' + token);
        return this.http.get<any>(url, { headers: headers }).pipe(map(response => {
            this.setUserBackend(response);
            localStorage.setItem('currentUser', JSON.stringify(this.currentUserObj));
            this.currentUserSubject.next(this.currentUserObj);
            return response;
        }));
    }

    // remove user from local storage to log user out
    logout() {
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }

    //New Login with Google
    getGoogleData(data: any, authToken): Promise<any> {
        if (this.currentUserObj == null) {
            this.currentUserObj = new User();
        }
        this.currentUserObj.userGoogle = data;
        this.currentUserObj.email = data.email;
        this.currentUserObj.token = authToken;

        return Promise.resolve();
    }

    logoutWithGoogle(): void {
        google.account.id.disableAutoSelect();
        this.logout();
    }

    //#FER-13: tracciamento log
    logoutLog(token: string) {
        let url = this.url
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', 'Bearer ' + token);
        return this.http.put(url, { headers: headers })
    }

    loadPhotoUrl(url): Observable<Blob> {
        let headers = new HttpHeaders();
        let token = null;
        if (this.currentUserObj != null && typeof this.currentUserObj != typeof undefined) {
            if (this.currentUserObj.token != null && typeof this.currentUserObj.token != typeof undefined) {
                token = this.currentUserObj.token;
            }
        }
        if (token == null || typeof token == typeof undefined) {
            if (localStorage.hasOwnProperty("currentUser")) {
                let cu = JSON.parse(localStorage.currentUser);
                if (cu.hasOwnProperty('token')) {
                    token = cu.token;
                }
            }
        }
        headers = headers.set('Authorization', 'Bearer ' + token);
        headers.set('Access-Control-Allow-Headers', 'Content-Type, Authorization');
        return this.http.get(url, {
            responseType: "blob",
            headers: headers
        });
    }

    //Controllo se bisogna fare un refresh del token
    isNeedRefreshToken(currentUser, minutiOffset: number) {
        let refreshToken = false;
        if (currentUser.userGoogle) {
            if (currentUser.userGoogle.response) {
                if (currentUser.userGoogle.response.expires_at) {
                    let now = new Date();
                    let expires_at = new Date(currentUser.userGoogle.response.expires_at);
                    let diffMinutes = (expires_at.getTime() - now.getTime()) / (1000 * 60);
                    let diff = parseInt(diffMinutes.toString(), 10);
                    if (diff >= 0) {
                        if (diff <= minutiOffset) {
                            refreshToken = true;
                        }
                    }
                }
            }
        }
        return refreshToken;
    }



    //Controlla se il token è scaduto
    isExparedToken(currentUser) {
        let res = true;
        if (currentUser != null && typeof currentUser != typeof undefined) {
            if (currentUser.userGoogle) {
                if (currentUser.userGoogle.exp) {
                    let now = new Date();
                    let exp = currentUser.userGoogle.exp + '000'
                    let expires_at = new Date(parseInt(exp));
                    res = (expires_at <= now)
                }
            }
        }
        return res;
    }

}